import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Row, Col, Card, Table, Button, Form,
  InputGroup, Badge, Spinner, Modal, Pagination, Nav
} from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const DataTindakan = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState({ date: '', clock: '' });

  // ── Tab Aktif ──
  const [activeTab, setActiveTab] = useState('tindakan');

  // ═══════════════════════════════════
  // TAB 1 – MASTER TINDAKAN
  // ═══════════════════════════════════
  const [tindakanList, setTindakanList] = useState([]);
  const [isLoadingT, setIsLoadingT] = useState(false);
  const [fetchErrorT, setFetchErrorT] = useState('');
  const [searchT, setSearchT] = useState('');
  const [filterPendamping, setFilterPendamping] = useState('');
  const [pageT, setPageT] = useState(1);
  const [limitT, setLimitT] = useState(10);

  const [formKdT, setFormKdT] = useState('');
  const [formNmT, setFormNmT] = useState('');
  const [formPendamping, setFormPendamping] = useState('Tidak');
  const [formVclaim, setFormVclaim] = useState('');
  const [isEditingT, setIsEditingT] = useState(false);
  const [showModalT, setShowModalT] = useState(false);

  const mockTindakan = [
    { kd_tindakan: "03148", nm_pendamping: "Tidak", nm_tindakan: "Administrasi - Operasi Besar",  vclaim: "" },
    { kd_tindakan: "03146", nm_pendamping: "Tidak", nm_tindakan: "Administrasi - Operasi Kecil",  vclaim: "" },
    { kd_tindakan: "03149", nm_pendamping: "Tidak", nm_tindakan: "Administrasi - Operasi Khusus", vclaim: "" },
  ];

  // ═══════════════════════════════════
  // TAB 2 – KELOMPOK TINDAKAN
  // ═══════════════════════════════════
  const [kelompokList, setKelompokList] = useState([]);
  const [isLoadingK, setIsLoadingK] = useState(false);
  const [fetchErrorK, setFetchErrorK] = useState('');
  const [searchK, setSearchK] = useState('');
  const [filterPaket, setFilterPaket] = useState('');
  const [pageK, setPageK] = useState(1);
  const [limitK, setLimitK] = useState(10);

  const [formKdK, setFormKdK] = useState('');
  const [formNmK, setFormNmK] = useState('');
  const [formPaket, setFormPaket] = useState('Tidak');
  const [isEditingK, setIsEditingK] = useState(false);
  const [showModalK, setShowModalK] = useState(false);

  const mockKelompok = [
    { kd_kelompok: "001", nm_kelompok: "Jasa Dokter Umum",          paket: "Tidak" },
    { kd_kelompok: "002", nm_kelompok: "Jasa Dokter Spesialis",     paket: "Tidak" },
    { kd_kelompok: "006", nm_kelompok: "Jasa Dokter Sub Spesialis", paket: "Tidak" },
  ];

  // ═══════════════════════════════════
  // TAB 3 – TARIF TINDAKAN
  // ═══════════════════════════════════
  const [tarifList, setTarifList] = useState([]);
  const [isLoadingTR, setIsLoadingTR] = useState(false);
  const [fetchErrorTR, setFetchErrorTR] = useState('');
  const [searchTR, setSearchTR] = useState('');
  const [pageTR, setPageTR] = useState(1);
  const [limitTR, setLimitTR] = useState(10);

  // Filter Tarif berdasarkan kelompok & klasifikasi
  const [filterKelompokTR, setFilterKelompokTR] = useState('');
  const [filterKlasifikasiTR, setFilterKlasifikasiTR] = useState('');

  // List master untuk combobox filter tarif
  const [kelompokOptions, setKelompokOptions] = useState([]);
  const [klasifikasiOptions, setKlasifikasiOptions] = useState([]);

  const mockTarif = [
    {
      kd_kelompok: "001", kd_klasifikasi: "001", kd_tindakan: "01084",
      kelas1: 0, kelas2a: 0, kelas2b: 0, kelas3: 0, kelasicu: 0,
      kelasisolasi: 0, kelasperina: 0, kelassehat: 0, kelasutama: 0, kelasvip: 0,
      nm_tindakan: "Vaksin Hepatitis B Anak", nonkelas: 5000, pendamping: "X"
    },
    {
      kd_kelompok: "001", kd_klasifikasi: "001", kd_tindakan: "01122",
      kelas1: 0, kelas2a: 0, kelas2b: 0, kelas3: 0, kelasicu: 0,
      kelasisolasi: 0, kelasperina: 0, kelassehat: 0, kelasutama: 0, kelasvip: 0,
      nm_tindakan: "Corpus Alienum Otot", nonkelas: 225000, pendamping: "X"
    },
  ];

  // ═══════════════════════════════════
  // TAB 4 – TINDAKAN OK
  // ═══════════════════════════════════
  const [tindakanOKList, setTindakanOKList] = useState([]);
  const [isLoadingOK, setIsLoadingOK] = useState(false);
  const [fetchErrorOK, setFetchErrorOK] = useState('');
  const [searchOK, setSearchOK] = useState('');
  const [pageOK, setPageOK] = useState(1);
  const [limitOK, setLimitOK] = useState(10);

  // Filter Tindakan OK
  const [filterKelompokOK, setFilterKelompokOK] = useState('');
  const [filterKlasifikasiOK, setFilterKlasifikasiOK] = useState('');
  const [filterTindakanOK, setFilterTindakanOK] = useState('');

  // Combobox options khusus tab OK (berbagi kelompokOptions & klasifikasiOptions dari tab tarif)
  const [tindakanOptions, setTindakanOptions] = useState([]);

  // ── Fetch Tindakan + Kelompok (dari 1 endpoint) ──
  const fetchTindakan = async () => {
    setIsLoadingT(true);
    setFetchErrorT('');
    const apiUrl = getApiUrl();
    try {
      const res = await fetch(`${apiUrl}/show_tindakan`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const json = await res.json();
      setTindakanList(json?.list_tindakan || mockTindakan);
      if (json?.list_kelompok) setKelompokList(json.list_kelompok);
      else setKelompokList(mockKelompok);
    } catch (err) {
      console.warn('Gagal /show_tindakan:', err);
      setTindakanList(mockTindakan);
      setKelompokList(mockKelompok);
      setFetchErrorT('Menggunakan data lokal. Gagal terhubung ke server backend.');
    } finally {
      setIsLoadingT(false);
    }
  };

  const fetchKelompok = async () => {
    setIsLoadingK(true);
    setFetchErrorK('');
    const apiUrl = getApiUrl();
    try {
      const res = await fetch(`${apiUrl}/show_tindakan`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const json = await res.json();
      setKelompokList(json?.list_kelompok || mockKelompok);
    } catch (err) {
      console.warn('Gagal /show_tindakan (kelompok):', err);
      setKelompokList(mockKelompok);
      setFetchErrorK('Menggunakan data lokal. Gagal terhubung ke server backend.');
    } finally {
      setIsLoadingK(false);
    }
  };

  const fetchTarif = async () => {
    setIsLoadingTR(true);
    setFetchErrorTR('');
    const apiUrl = getApiUrl();
    try {
      // Fetch tarif tindakan
      const resTarif = await fetch(`${apiUrl}/show_tarif_tindakan`);
      if (!resTarif.ok) throw new Error(`HTTP error! status: ${resTarif.status}`);
      const jsonTarif = await resTarif.json();
      setTarifList(jsonTarif?.list_tarif_tindakan || mockTarif);

      // Fetch kelompok untuk combobox filter (dari show_kelompok)
      try {
        const resKel = await fetch(`${apiUrl}/show_kelompok`);
        const jsonKel = await resKel.json();
        if (jsonKel?.list_kelompok) setKelompokOptions(jsonKel.list_kelompok);
        else setKelompokOptions(mockKelompok);
      } catch { setKelompokOptions(mockKelompok); }

      // Fetch klasifikasi untuk combobox filter (dari show_klasifikasi)
      try {
        const resKlas = await fetch(`${apiUrl}/show_klasifikasi`);
        const jsonKlas = await resKlas.json();
        if (jsonKlas?.list_klasifikasi) setKlasifikasiOptions(jsonKlas.list_klasifikasi);
      } catch { setKlasifikasiOptions([]); }

    } catch (err) {
      console.warn('Gagal /show_tarif_tindakan:', err);
      setTarifList(mockTarif);
      setKelompokOptions(mockKelompok);
      setFetchErrorTR('Menggunakan data lokal. Gagal terhubung ke server backend.');
    } finally {
      setIsLoadingTR(false);
    }
  };

  // ── Fetch Tindakan OK ──
  const fetchTindakanOK = async () => {
    setIsLoadingOK(true);
    setFetchErrorOK('');
    const apiUrl = getApiUrl();
    try {
      const res = await fetch(`${apiUrl}/show_tindakanok`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const json = await res.json();
      setTindakanOKList(json?.list_tindakanok || []);

      // Combobox kd_tindakan dari show_tindakan
      try {
        const resT = await fetch(`${apiUrl}/show_tindakan`);
        const jsonT = await resT.json();
        if (jsonT?.list_tindakan) setTindakanOptions(jsonT.list_tindakan);
      } catch { setTindakanOptions([]); }

      // Kelompok & Klasifikasi pakai options yang sama
      try {
        const resKel = await fetch(`${apiUrl}/show_kelompok`);
        const jsonKel = await resKel.json();
        if (jsonKel?.list_kelompok) setKelompokOptions(jsonKel.list_kelompok);
      } catch { setKelompokOptions(mockKelompok); }

      try {
        const resKlas = await fetch(`${apiUrl}/show_klasifikasi`);
        const jsonKlas = await resKlas.json();
        if (jsonKlas?.list_klasifikasi) setKlasifikasiOptions(jsonKlas.list_klasifikasi);
      } catch { setKlasifikasiOptions([]); }

    } catch (err) {
      console.warn('Gagal /show_tindakanok:', err);
      setTindakanOKList([]);
      setFetchErrorOK('Menggunakan data lokal. Gagal terhubung ke server backend.');
    } finally {
      setIsLoadingOK(false);
    }
  };

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID') + ' WIB',
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    fetchTindakan();
    fetchTarif();
    fetchTindakanOK();
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ═══════════════════════
  // Computed – Tindakan
  // ═══════════════════════
  const filteredT = tindakanList.filter(item => {
    const q = searchT.toLowerCase();
    const matchSearch =
      (item.nm_tindakan || '').toLowerCase().includes(q) ||
      (item.kd_tindakan || '').toLowerCase().includes(q) ||
      (item.vclaim || '').toLowerCase().includes(q);
    const matchPendamping = filterPendamping ? item.nm_pendamping === filterPendamping : true;
    return matchSearch && matchPendamping;
  });
  const uniquePendamping = [...new Set(tindakanList.map(d => d.nm_pendamping))].filter(Boolean);
  const lastT = pageT * limitT; const firstT = lastT - limitT;
  const itemsT = filteredT.slice(firstT, lastT);
  const pagesT = Math.ceil(filteredT.length / limitT);

  // ═══════════════════════
  // Computed – Kelompok
  // ═══════════════════════
  const filteredK = kelompokList.filter(item => {
    const q = searchK.toLowerCase();
    const matchSearch =
      (item.nm_kelompok || '').toLowerCase().includes(q) ||
      (item.kd_kelompok || '').toLowerCase().includes(q);
    const matchPaket = filterPaket ? item.paket === filterPaket : true;
    return matchSearch && matchPaket;
  });
  const uniquePaket = [...new Set(kelompokList.map(d => d.paket))].filter(Boolean);
  const lastK = pageK * limitK; const firstK = lastK - limitK;
  const itemsK = filteredK.slice(firstK, lastK);
  const pagesK = Math.ceil(filteredK.length / limitK);

  // ═══════════════════════
  // Computed – Tarif
  // ═══════════════════════
  const filteredTR = tarifList.filter(item => {
    const q = searchTR.toLowerCase();
    const matchSearch =
      (item.nm_tindakan || '').toLowerCase().includes(q) ||
      (item.kd_tindakan || '').toLowerCase().includes(q);
    const matchKelompok = filterKelompokTR ? item.kd_kelompok === filterKelompokTR : true;
    const matchKlasifikasi = filterKlasifikasiTR ? item.kd_klasifikasi === filterKlasifikasiTR : true;
    return matchSearch && matchKelompok && matchKlasifikasi;
  });
  const lastTR = pageTR * limitTR; const firstTR = lastTR - limitTR;
  const itemsTR = filteredTR.slice(firstTR, lastTR);
  const pagesTR = Math.ceil(filteredTR.length / limitTR);

  // ── Handlers Tindakan ──
  const handleEditT = (item) => {
    setFormKdT(item.kd_tindakan || ''); setFormNmT(item.nm_tindakan || '');
    setFormPendamping(item.nm_pendamping || 'Tidak'); setFormVclaim(item.vclaim || '');
    setIsEditingT(true); setShowModalT(true);
  };
  const handleClearT = () => { setFormKdT(''); setFormNmT(''); setFormPendamping('Tidak'); setFormVclaim(''); setIsEditingT(false); setShowModalT(false); };
  const handleSubmitT = (e) => {
    e.preventDefault();
    const rec = { kd_tindakan: formKdT, nm_tindakan: formNmT, nm_pendamping: formPendamping, vclaim: formVclaim };
    if (isEditingT) setTindakanList(prev => prev.map(t => t.kd_tindakan === formKdT ? rec : t));
    else setTindakanList(prev => [...prev, rec]);
    handleClearT();
  };
  const handleDeleteT = (kd) => { if (window.confirm('Hapus data tindakan ini?')) setTindakanList(prev => prev.filter(t => t.kd_tindakan !== kd)); };

  // ── Handlers Kelompok ──
  const handleEditK = (item) => { setFormKdK(item.kd_kelompok || ''); setFormNmK(item.nm_kelompok || ''); setFormPaket(item.paket || 'Tidak'); setIsEditingK(true); setShowModalK(true); };
  const handleClearK = () => { setFormKdK(''); setFormNmK(''); setFormPaket('Tidak'); setIsEditingK(false); setShowModalK(false); };
  const handleSubmitK = (e) => {
    e.preventDefault();
    const rec = { kd_kelompok: formKdK, nm_kelompok: formNmK, paket: formPaket };
    if (isEditingK) setKelompokList(prev => prev.map(k => k.kd_kelompok === formKdK ? rec : k));
    else setKelompokList(prev => [...prev, rec]);
    handleClearK();
  };
  const handleDeleteK = (kd) => { if (window.confirm('Hapus data kelompok tindakan ini?')) setKelompokList(prev => prev.filter(k => k.kd_kelompok !== kd)); };

  // ── Helper Pagination ──
  const renderPagination = (currentPage, totalPages, setPage) => {
    if (totalPages <= 1) return null;
    return (
      <div className="d-flex justify-content-center mt-3">
        <Pagination size="sm" className="mb-0">
          <Pagination.First onClick={() => setPage(1)} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => setPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
          {[...Array(Math.min(totalPages, 10))].map((_, i) => (
            <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setPage(i + 1)}>{i + 1}</Pagination.Item>
          ))}
          {totalPages > 10 && <Pagination.Ellipsis disabled />}
          <Pagination.Next onClick={() => setPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
          <Pagination.Last onClick={() => setPage(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
      </div>
    );
  };

  // ── Helper format rupiah ──
  const fmtRp = (val) => val > 0 ? `Rp ${Number(val).toLocaleString('id-ID')}` : <span className="text-muted">—</span>;

  // ── Tab Link Style ──
  const tabStyle = (key) => ({
    fontSize: '0.77rem', fontWeight: 600,
    color: activeTab === key ? '#0f172a' : '#94a3b8',
    background: activeTab === key ? '#ffffff' : 'transparent',
    border: activeTab === key ? '1.5px solid #cbd5e1' : '1.5px solid transparent',
    borderBottom: activeTab === key ? '2px solid #0d9488' : 'none',
    borderRadius: '8px 8px 0 0',
    padding: '0.3rem 0.85rem',
  });

  // ══════════════════════════════════════════════════
  // RENDER
  // ══════════════════════════════════════════════════
  return (
    <div style={styles.appContainer}>

      {/* ══ NAVBAR ══ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home"
            onClick={e => { e.preventDefault(); navigate('/home'); }}>
            <div className="d-flex align-items-center justify-content-center me-2 rounded bg-white bg-opacity-10 p-1">
              <i className="bi bi-shield-plus text-warning fs-4"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem' }}>
                SIMRS2 <span style={{ fontSize: '0.78rem', color: '#2dd4bf' }}>Finance</span>
              </div>
              <div className="text-white-50" style={{ fontSize: '0.62rem' }}>Sistem Informasi Rumah Sakit</div>
            </div>
          </a>
          <div className="d-flex align-items-center gap-3 ms-auto">
            <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
              <div className="fw-semibold text-white-50" style={{ fontSize: '0.73rem' }}>{time.date}</div>
              <div className="fw-bold" style={{ fontSize: '0.78rem', color: '#2dd4bf' }}>{time.clock}</div>
            </div>
            <Button variant="light" size="sm" onClick={() => navigate('/home')} className="d-flex align-items-center gap-1">
              <i className="bi bi-house-door-fill" style={{ color: '#0d9488' }}></i>
              <span>Kembali</span>
            </Button>
          </div>
        </Container>
      </nav>

      {/* ══ MAIN CONTENT ══ */}
      <div style={styles.mainContent}>
        <Card style={styles.mainCard} className="shadow-sm border-0">

          {/* ── Tab Header ── */}
          <div style={{ ...styles.bgMenuHeader, borderRadius: '12px 12px 0 0' }}>
            <div className="d-flex align-items-end justify-content-between px-3 pt-2">
              {/* Tab Pills */}
              <Nav variant="tabs" activeKey={activeTab} onSelect={k => setActiveTab(k)} className="border-bottom-0 gap-1 flex-wrap">
                <Nav.Item>
                  <Nav.Link eventKey="tindakan" style={tabStyle('tindakan')}>
                    <i className="bi bi-clipboard2-pulse-fill me-1 text-warning"></i> Master Tindakan
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="kelompok" style={tabStyle('kelompok')}>
                    <i className="bi bi-collection-fill me-1 text-warning"></i> Kelompok Tindakan
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="tarif" style={tabStyle('tarif')}>
                    <i className="bi bi-cash-coin me-1 text-warning"></i> Tarif Tindakan
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="tindakanok" style={tabStyle('tindakanok')}>
                    <i className="bi bi-check2-circle me-1 text-warning"></i> Tindakan OK
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              {/* Action Buttons */}
              <div className="d-flex gap-2 align-items-center pb-1 ms-auto">
                {activeTab === 'tindakan' && (
                  <>
                    <Button size="sm" onClick={() => { handleClearT(); setShowModalT(true); }}
                      className="fw-bold" style={{ fontSize: '0.73rem', background: '#0d9488', border: 'none', color: '#fff' }}>
                      <i className="bi bi-plus-circle-fill me-1"></i> Tambah Tindakan
                    </Button>
                    <Button variant="outline-light" size="sm" onClick={fetchTindakan} disabled={isLoadingT} style={{ fontSize: '0.7rem' }}>
                      {isLoadingT ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                    </Button>
                  </>
                )}
                {activeTab === 'kelompok' && (
                  <>
                    <Button size="sm" onClick={() => { handleClearK(); setShowModalK(true); }}
                      className="fw-bold" style={{ fontSize: '0.73rem', background: '#7c3aed', border: 'none', color: '#fff' }}>
                      <i className="bi bi-plus-circle-fill me-1"></i> Tambah Kelompok
                    </Button>
                    <Button variant="outline-light" size="sm" onClick={fetchKelompok} disabled={isLoadingK} style={{ fontSize: '0.7rem' }}>
                      {isLoadingK ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                    </Button>
                  </>
                )}
                {activeTab === 'tarif' && (
                  <Button variant="outline-light" size="sm" onClick={fetchTarif} disabled={isLoadingTR} style={{ fontSize: '0.7rem' }}>
                    {isLoadingTR ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                  </Button>
                )}
                {activeTab === 'tindakanok' && (
                  <Button variant="outline-light" size="sm" onClick={fetchTindakanOK} disabled={isLoadingOK} style={{ fontSize: '0.7rem' }}>
                    {isLoadingOK ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                  </Button>
                )}
              </div>
            </div>
          </div>

          {/* ══ TAB CONTENT ══ */}
          <Card.Body className="p-2">

            {/* ─────────────────────────────────
                TAB 1: MASTER TINDAKAN
            ───────────────────────────────── */}
            {activeTab === 'tindakan' && (
              <>
                <Row className="g-2 mb-3">
                  <Col md={5}>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light text-muted"><i className="bi bi-search"></i></InputGroup.Text>
                      <Form.Control type="text" placeholder="Cari kode, nama, vclaim..." value={searchT}
                        onChange={e => { setSearchT(e.target.value); setPageT(1); }} style={{ fontSize: '0.78rem' }} />
                    </InputGroup>
                  </Col>
                  <Col md={3}>
                    <Form.Select size="sm" value={filterPendamping}
                      onChange={e => { setFilterPendamping(e.target.value); setPageT(1); }} style={{ fontSize: '0.78rem' }}>
                      <option value="">Semua Pendamping</option>
                      {uniquePendamping.map((p, i) => <option key={i} value={p}>{p}</option>)}
                    </Form.Select>
                  </Col>
                  <Col md={2}>
                    <Form.Select size="sm" value={limitT}
                      onChange={e => { setLimitT(Number(e.target.value)); setPageT(1); }} style={{ fontSize: '0.78rem' }}>
                      <option value={10}>10 Baris</option><option value={20}>20 Baris</option>
                      <option value={50}>50 Baris</option><option value={100}>100 Baris</option>
                    </Form.Select>
                  </Col>
                </Row>
                {fetchErrorT && <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}><i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchErrorT}</div>}
                <div className="table-responsive" style={{ minHeight: '320px' }}>
                  <Table responsive striped bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
                    <thead className="table-light text-secondary sticky-top">
                      <tr>
                        <th style={{ width: '40px' }}>#</th>
                        <th style={{ width: '110px' }}>Kode</th>
                        <th>Nama Tindakan</th>
                        <th style={{ width: '120px' }}>Pendamping</th>
                        <th style={{ width: '150px' }}>VClaim</th>
                        <th style={{ width: '90px' }} className="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingT ? (
                        <tr><td colSpan="6" className="text-center py-5 text-muted"><Spinner animation="border" variant="teal" className="mb-2" /><div>Memuat data...</div></td></tr>
                      ) : itemsT.length > 0 ? itemsT.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-muted text-center">{firstT + idx + 1}</td>
                          <td><span className="fw-bold font-monospace" style={{ color: '#0d9488' }}>{item.kd_tindakan}</span></td>
                          <td className="fw-semibold">{item.nm_tindakan}</td>
                          <td><Badge bg={item.nm_pendamping === 'Ya' ? 'success' : 'secondary'} style={styles.badge}>{item.nm_pendamping}</Badge></td>
                          <td>{item.vclaim ? <span className="font-monospace text-primary">{item.vclaim}</span> : <span className="text-muted fst-italic">—</span>}</td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-1">
                              <Button size="sm" variant="outline-primary" onClick={() => handleEditT(item)} style={styles.actionBtn}><i className="bi bi-pencil-fill"></i></Button>
                              <Button size="sm" variant="outline-danger" onClick={() => handleDeleteT(item.kd_tindakan)} style={styles.actionBtn}><i className="bi bi-trash-fill"></i></Button>
                            </div>
                          </td>
                        </tr>
                      )) : <tr><td colSpan="6" className="text-center py-4 text-muted">Tidak ada data tindakan.</td></tr>}
                    </tbody>
                  </Table>
                </div>
                {renderPagination(pageT, pagesT, setPageT)}
                <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
                  <span>Menampilkan <strong>{filteredT.length > 0 ? firstT + 1 : 0}–{Math.min(lastT, filteredT.length)}</strong> dari <strong>{filteredT.length}</strong> tindakan</span>
                  <span>IP Server: <strong>{getApiUrl()}</strong></span>
                </div>
              </>
            )}

            {/* ─────────────────────────────────
                TAB 2: KELOMPOK TINDAKAN
            ───────────────────────────────── */}
            {activeTab === 'kelompok' && (
              <>
                <Row className="g-2 mb-3">
                  <Col md={5}>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light text-muted"><i className="bi bi-search"></i></InputGroup.Text>
                      <Form.Control type="text" placeholder="Cari kode atau nama kelompok..." value={searchK}
                        onChange={e => { setSearchK(e.target.value); setPageK(1); }} style={{ fontSize: '0.78rem' }} />
                    </InputGroup>
                  </Col>
                  <Col md={3}>
                    <Form.Select size="sm" value={filterPaket}
                      onChange={e => { setFilterPaket(e.target.value); setPageK(1); }} style={{ fontSize: '0.78rem' }}>
                      <option value="">Semua Paket</option>
                      {uniquePaket.map((p, i) => <option key={i} value={p}>{p}</option>)}
                    </Form.Select>
                  </Col>
                  <Col md={2}>
                    <Form.Select size="sm" value={limitK}
                      onChange={e => { setLimitK(Number(e.target.value)); setPageK(1); }} style={{ fontSize: '0.78rem' }}>
                      <option value={10}>10 Baris</option><option value={20}>20 Baris</option>
                      <option value={50}>50 Baris</option><option value={100}>100 Baris</option>
                    </Form.Select>
                  </Col>
                </Row>
                {fetchErrorK && <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}><i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchErrorK}</div>}
                <div className="table-responsive" style={{ minHeight: '320px' }}>
                  <Table responsive striped bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
                    <thead className="table-light text-secondary sticky-top">
                      <tr>
                        <th style={{ width: '40px' }}>#</th>
                        <th style={{ width: '110px' }}>Kode Kelompok</th>
                        <th>Nama Kelompok</th>
                        <th style={{ width: '120px' }}>Paket</th>
                        <th style={{ width: '90px' }} className="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingK ? (
                        <tr><td colSpan="5" className="text-center py-5 text-muted"><Spinner animation="border" style={{ color: '#7c3aed' }} className="mb-2" /><div>Memuat data kelompok...</div></td></tr>
                      ) : itemsK.length > 0 ? itemsK.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-muted text-center">{firstK + idx + 1}</td>
                          <td><span className="fw-bold font-monospace" style={{ color: '#7c3aed' }}>{item.kd_kelompok}</span></td>
                          <td className="fw-semibold">{item.nm_kelompok}</td>
                          <td><Badge bg={item.paket === 'Ya' ? 'warning' : 'secondary'} style={styles.badge}>{item.paket}</Badge></td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-1">
                              <Button size="sm" variant="outline-primary" onClick={() => handleEditK(item)} style={styles.actionBtn}><i className="bi bi-pencil-fill"></i></Button>
                              <Button size="sm" variant="outline-danger" onClick={() => handleDeleteK(item.kd_kelompok)} style={styles.actionBtn}><i className="bi bi-trash-fill"></i></Button>
                            </div>
                          </td>
                        </tr>
                      )) : <tr><td colSpan="5" className="text-center py-4 text-muted">Tidak ada data kelompok tindakan.</td></tr>}
                    </tbody>
                  </Table>
                </div>
                {renderPagination(pageK, pagesK, setPageK)}
                <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
                  <span>Menampilkan <strong>{filteredK.length > 0 ? firstK + 1 : 0}–{Math.min(lastK, filteredK.length)}</strong> dari <strong>{filteredK.length}</strong> kelompok</span>
                  <span>IP Server: <strong>{getApiUrl()}</strong></span>
                </div>
              </>
            )}

            {/* ─────────────────────────────────
                TAB 3: TARIF TINDAKAN
            ───────────────────────────────── */}
            {activeTab === 'tarif' && (
              <>
                {/* ── Filter Row: Kelompok + Klasifikasi + Search + Limit ── */}
                <Row className="g-2 mb-2">
                  {/* Filter Kelompok */}
                  <Col md={3}>
                    <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>
                      <i className="bi bi-collection-fill me-1" style={{ color: '#7c3aed' }}></i>Filter Kelompok
                    </Form.Label>
                    <Form.Select size="sm" value={filterKelompokTR}
                      onChange={e => { setFilterKelompokTR(e.target.value); setPageTR(1); }}
                      style={{ fontSize: '0.78rem' }}>
                      <option value="">— Semua Kelompok —</option>
                      {kelompokOptions.map((k, i) => (
                        <option key={i} value={k.kd_kelompok}>
                          [{k.kd_kelompok}] {k.nm_kelompok}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  {/* Filter Klasifikasi */}
                  <Col md={3}>
                    <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>
                      <i className="bi bi-tags-fill me-1 text-primary"></i>Filter Klasifikasi
                    </Form.Label>
                    <Form.Select size="sm" value={filterKlasifikasiTR}
                      onChange={e => { setFilterKlasifikasiTR(e.target.value); setPageTR(1); }}
                      style={{ fontSize: '0.78rem' }}>
                      <option value="">— Semua Klasifikasi —</option>
                      {klasifikasiOptions.map((k, i) => (
                        <option key={i} value={k.kd_klas}>
                          [{k.kd_klas}] {k.nm_klas}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  {/* Search */}
                  <Col md={4}>
                    <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>
                      <i className="bi bi-search me-1"></i>Pencarian
                    </Form.Label>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light text-muted"><i className="bi bi-search"></i></InputGroup.Text>
                      <Form.Control type="text" placeholder="Cari kode atau nama tindakan..." value={searchTR}
                        onChange={e => { setSearchTR(e.target.value); setPageTR(1); }} style={{ fontSize: '0.78rem' }} />
                    </InputGroup>
                  </Col>

                  {/* Limit */}
                  <Col md={2}>
                    <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>Baris / Halaman</Form.Label>
                    <Form.Select size="sm" value={limitTR}
                      onChange={e => { setLimitTR(Number(e.target.value)); setPageTR(1); }}
                      style={{ fontSize: '0.78rem' }}>
                      <option value={10}>10 Baris</option><option value={20}>20 Baris</option>
                      <option value={50}>50 Baris</option><option value={100}>100 Baris</option>
                    </Form.Select>
                  </Col>
                </Row>

                {fetchErrorTR && <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}><i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchErrorTR}</div>}

                {/* Tarif Badge Info */}
                {(filterKelompokTR || filterKlasifikasiTR) && (
                  <div className="d-flex gap-2 mb-2 flex-wrap">
                    {filterKelompokTR && (
                      <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.72rem' }}>
                        <i className="bi bi-funnel-fill me-1" style={{ color: '#7c3aed' }}></i>
                        Kelompok: <strong>{filterKelompokTR}</strong>
                        <span className="ms-2 text-danger" style={{ cursor: 'pointer' }} onClick={() => setFilterKelompokTR('')}>✕</span>
                      </Badge>
                    )}
                    {filterKlasifikasiTR && (
                      <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.72rem' }}>
                        <i className="bi bi-funnel-fill me-1 text-primary"></i>
                        Klasifikasi: <strong>{filterKlasifikasiTR}</strong>
                        <span className="ms-2 text-danger" style={{ cursor: 'pointer' }} onClick={() => setFilterKlasifikasiTR('')}>✕</span>
                      </Badge>
                    )}
                  </div>
                )}

                {/* Tabel Tarif – Scroll horizontal untuk kolom tarif per kelas */}
                <div className="table-responsive" style={{ minHeight: '320px' }}>
                  <Table responsive striped bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem', minWidth: '980px' }}>
                    <thead className="table-light text-secondary sticky-top">
                      <tr>
                        <th style={{ width: '35px' }}>#</th>
                        <th style={{ width: '90px' }}>Kode</th>
                        <th style={{ minWidth: '180px' }}>Nama Tindakan</th>
                        <th style={{ width: '55px' }} className="text-center">Pendamping</th>
                        <th style={{ width: '90px' }} className="text-end">Non Kelas</th>
                        <th style={{ width: '80px' }} className="text-end">Kelas 1</th>
                        <th style={{ width: '80px' }} className="text-end">Kelas 2A</th>
                        <th style={{ width: '80px' }} className="text-end">Kelas 2B</th>
                        <th style={{ width: '80px' }} className="text-end">Kelas 3</th>
                        <th style={{ width: '80px' }} className="text-end">Kelas Utama</th>
                        <th style={{ width: '80px' }} className="text-end">VIP</th>
                        <th style={{ width: '80px' }} className="text-end">ICU</th>
                        <th style={{ width: '80px' }} className="text-end">Isolasi</th>
                        <th style={{ width: '80px' }} className="text-end">Perina</th>
                        <th style={{ width: '80px' }} className="text-end">Sehat</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingTR ? (
                        <tr><td colSpan="15" className="text-center py-5 text-muted">
                          <Spinner animation="border" style={{ color: '#d97706' }} className="mb-2" /><div>Memuat data tarif tindakan...</div>
                        </td></tr>
                      ) : itemsTR.length > 0 ? itemsTR.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-muted text-center">{firstTR + idx + 1}</td>
                          <td><span className="fw-bold font-monospace" style={{ color: '#d97706', fontSize: '0.72rem' }}>{item.kd_tindakan}</span></td>
                          <td className="fw-semibold" style={{ fontSize: '0.75rem' }}>{item.nm_tindakan}</td>
                          <td className="text-center">
                            <Badge bg={item.pendamping === 'V' ? 'success' : 'light'} text={item.pendamping === 'V' ? 'white' : 'dark'}
                              className="border" style={{ fontSize: '0.68rem' }}>{item.pendamping}</Badge>
                          </td>
                          <td className="text-end fw-bold" style={{ color: item.nonkelas > 0 ? '#059669' : '#94a3b8' }}>{fmtRp(item.nonkelas)}</td>
                          <td className="text-end">{fmtRp(item.kelas1)}</td>
                          <td className="text-end">{fmtRp(item.kelas2a)}</td>
                          <td className="text-end">{fmtRp(item.kelas2b)}</td>
                          <td className="text-end">{fmtRp(item.kelas3)}</td>
                          <td className="text-end">{fmtRp(item.kelasutama)}</td>
                          <td className="text-end">{fmtRp(item.kelasvip)}</td>
                          <td className="text-end">{fmtRp(item.kelasicu)}</td>
                          <td className="text-end">{fmtRp(item.kelasisolasi)}</td>
                          <td className="text-end">{fmtRp(item.kelasperina)}</td>
                          <td className="text-end">{fmtRp(item.kelassehat)}</td>
                        </tr>
                      )) : (
                        <tr><td colSpan="15" className="text-center py-4 text-muted">
                          {filterKelompokTR || filterKlasifikasiTR
                            ? 'Tidak ada tarif tindakan untuk filter yang dipilih.'
                            : 'Tidak ada data tarif tindakan.'}
                        </td></tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {renderPagination(pageTR, pagesTR, setPageTR)}

                <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
                  <span>
                    Menampilkan <strong>{filteredTR.length > 0 ? firstTR + 1 : 0}–{Math.min(lastTR, filteredTR.length)}</strong> dari <strong>{filteredTR.length}</strong> tarif (Total: {tarifList.length})
                  </span>
                  <span>IP Server: <strong>{getApiUrl()}</strong></span>
                </div>
              </>
            )}

            {/* ─────────────────────────────────
                TAB 4: TINDAKAN OK
            ───────────────────────────────── */}
            {activeTab === 'tindakanok' && (() => {
              // Computed
              const filteredOK = tindakanOKList.filter(item => {
                const q = searchOK.toLowerCase();
                const matchSearch =
                  (item.nm_tindakan || '').toLowerCase().includes(q) ||
                  (item.kd_tindakan || '').toLowerCase().includes(q);
                const matchKelompok = filterKelompokOK ? item.kd_kelompok === filterKelompokOK : true;
                const matchKlasifikasi = filterKlasifikasiOK ? item.kd_klasifikasi === filterKlasifikasiOK : true;
                const matchTindakan = filterTindakanOK ? item.kd_tindakan === filterTindakanOK : true;
                return matchSearch && matchKelompok && matchKlasifikasi && matchTindakan;
              });
              const lastOK = pageOK * limitOK;
              const firstOK = lastOK - limitOK;
              const itemsOK = filteredOK.slice(firstOK, lastOK);
              const pagesOK = Math.ceil(filteredOK.length / limitOK);

              return (
                <>
                  {/* ── Filter Row ── */}
                  <Row className="g-2 mb-2">
                    {/* Filter Kelompok */}
                    <Col md={3}>
                      <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>
                        <i className="bi bi-collection-fill me-1" style={{ color: '#7c3aed' }}></i>Kelompok
                      </Form.Label>
                      <Form.Select size="sm" value={filterKelompokOK}
                        onChange={e => { setFilterKelompokOK(e.target.value); setPageOK(1); }}
                        style={{ fontSize: '0.78rem' }}>
                        <option value="">— Semua Kelompok —</option>
                        {kelompokOptions.map((k, i) => (
                          <option key={i} value={k.kd_kelompok}>[{k.kd_kelompok}] {k.nm_kelompok}</option>
                        ))}
                      </Form.Select>
                    </Col>

                    {/* Filter Klasifikasi */}
                    <Col md={3}>
                      <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>
                        <i className="bi bi-tags-fill me-1 text-primary"></i>Klasifikasi
                      </Form.Label>
                      <Form.Select size="sm" value={filterKlasifikasiOK}
                        onChange={e => { setFilterKlasifikasiOK(e.target.value); setPageOK(1); }}
                        style={{ fontSize: '0.78rem' }}>
                        <option value="">— Semua Klasifikasi —</option>
                        {klasifikasiOptions.map((k, i) => (
                          <option key={i} value={k.kd_klas}>[{k.kd_klas}] {k.nm_klas}</option>
                        ))}
                      </Form.Select>
                    </Col>

                    {/* Filter Tindakan */}
                    <Col md={3}>
                      <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>
                        <i className="bi bi-clipboard2-pulse-fill me-1 text-warning"></i>Tindakan
                      </Form.Label>
                      <Form.Select size="sm" value={filterTindakanOK}
                        onChange={e => { setFilterTindakanOK(e.target.value); setPageOK(1); }}
                        style={{ fontSize: '0.78rem' }}>
                        <option value="">— Semua Tindakan —</option>
                        {tindakanOptions.map((t, i) => (
                          <option key={i} value={t.kd_tindakan}>[{t.kd_tindakan}] {t.nm_tindakan}</option>
                        ))}
                      </Form.Select>
                    </Col>

                    {/* Limit */}
                    <Col md={2}>
                      <Form.Label className="mb-1 fw-semibold text-muted" style={{ fontSize: '0.7rem' }}>Baris / Hal</Form.Label>
                      <Form.Select size="sm" value={limitOK}
                        onChange={e => { setLimitOK(Number(e.target.value)); setPageOK(1); }}
                        style={{ fontSize: '0.78rem' }}>
                        <option value={10}>10 Baris</option>
                        <option value={20}>20 Baris</option>
                        <option value={50}>50 Baris</option>
                        <option value={100}>100 Baris</option>
                      </Form.Select>
                    </Col>
                  </Row>

                  {/* Search */}
                  <Row className="g-2 mb-2">
                    <Col md={6}>
                      <InputGroup size="sm">
                        <InputGroup.Text className="bg-light text-muted"><i className="bi bi-search"></i></InputGroup.Text>
                        <Form.Control type="text" placeholder="Cari kode atau nama tindakan..." value={searchOK}
                          onChange={e => { setSearchOK(e.target.value); setPageOK(1); }} style={{ fontSize: '0.78rem' }} />
                      </InputGroup>
                    </Col>
                  </Row>

                  {/* Badge Filter Aktif */}
                  {(filterKelompokOK || filterKlasifikasiOK || filterTindakanOK) && (
                    <div className="d-flex gap-2 mb-2 flex-wrap">
                      {filterKelompokOK && (
                        <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.72rem' }}>
                          <i className="bi bi-funnel-fill me-1" style={{ color: '#7c3aed' }}></i>
                          Kelompok: <strong>{filterKelompokOK}</strong>
                          <span className="ms-2 text-danger" style={{ cursor: 'pointer' }} onClick={() => setFilterKelompokOK('')}>✕</span>
                        </Badge>
                      )}
                      {filterKlasifikasiOK && (
                        <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.72rem' }}>
                          <i className="bi bi-funnel-fill me-1 text-primary"></i>
                          Klasifikasi: <strong>{filterKlasifikasiOK}</strong>
                          <span className="ms-2 text-danger" style={{ cursor: 'pointer' }} onClick={() => setFilterKlasifikasiOK('')}>✕</span>
                        </Badge>
                      )}
                      {filterTindakanOK && (
                        <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.72rem' }}>
                          <i className="bi bi-clipboard2-pulse-fill me-1 text-warning"></i>
                          Tindakan: <strong>{filterTindakanOK}</strong>
                          <span className="ms-2 text-danger" style={{ cursor: 'pointer' }} onClick={() => setFilterTindakanOK('')}>✕</span>
                        </Badge>
                      )}
                    </div>
                  )}

                  {fetchErrorOK && (
                    <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                      <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchErrorOK}
                    </div>
                  )}

                  {/* Tabel */}
                  <div className="table-responsive" style={{ minHeight: '320px' }}>
                    <Table responsive striped bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
                      <thead className="table-light text-secondary sticky-top">
                        <tr>
                          <th style={{ width: '40px' }}>#</th>
                          <th style={{ width: '100px' }}>Kode Tindakan</th>
                          <th>Nama Tindakan</th>
                          <th style={{ width: '80px' }} className="text-center">Kelompok</th>
                          <th style={{ width: '85px' }} className="text-center">Klasifikasi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoadingOK ? (
                          <tr><td colSpan="5" className="text-center py-5 text-muted">
                            <Spinner animation="border" style={{ color: '#16a34a' }} className="mb-2" />
                            <div>Memuat data tindakan OK...</div>
                          </td></tr>
                        ) : itemsOK.length > 0 ? itemsOK.map((item, idx) => (
                          <tr key={idx}>
                            <td className="text-muted text-center">{firstOK + idx + 1}</td>
                            <td><span className="fw-bold font-monospace" style={{ color: '#16a34a' }}>{item.kd_tindakan}</span></td>
                            <td className="fw-semibold">{item.nm_tindakan}</td>
                            <td className="text-center">
                              <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.68rem', color: '#7c3aed' }}>{item.kd_kelompok}</Badge>
                            </td>
                            <td className="text-center">
                              <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.68rem', color: '#2563eb' }}>{item.kd_klasifikasi}</Badge>
                            </td>
                          </tr>
                        )) : (
                          <tr><td colSpan="5" className="text-center py-4 text-muted">
                            {filterKelompokOK || filterKlasifikasiOK || filterTindakanOK
                              ? 'Tidak ada tindakan OK untuk filter yang dipilih.'
                              : 'Tidak ada data tindakan OK.'}
                          </td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {renderPagination(pageOK, pagesOK, setPageOK)}

                  <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
                    <span>
                      Menampilkan <strong>{filteredOK.length > 0 ? firstOK + 1 : 0}–{Math.min(lastOK, filteredOK.length)}</strong> dari <strong>{filteredOK.length}</strong> tindakan OK (Total: {tindakanOKList.length})
                    </span>
                    <span>IP Server: <strong>{getApiUrl()}</strong></span>
                  </div>
                </>
              );
            })()}

          </Card.Body>
        </Card>
      </div>

      {/* ══════════════ MODAL FORM TINDAKAN ══════════════ */}
      <Modal show={showModalT} onHide={handleClearT} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-clipboard2-pulse-fill text-warning fs-5"></i>
            <span>{isEditingT ? `Edit Tindakan: ${formKdT}` : 'Tambah Tindakan Baru'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSubmitT}>
            <Form.Group className="mb-2">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode Tindakan</Form.Label>
              <Form.Control type="text" placeholder="Contoh: 03148" value={formKdT}
                onChange={e => setFormKdT(e.target.value)} disabled={isEditingT} required style={styles.formControl} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Tindakan</Form.Label>
              <Form.Control type="text" placeholder="Contoh: Administrasi - Operasi Besar" value={formNmT}
                onChange={e => setFormNmT(e.target.value)} required style={styles.formControl} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Pendamping</Form.Label>
              <Form.Select value={formPendamping} onChange={e => setFormPendamping(e.target.value)} style={styles.formSelect}>
                <option value="Tidak">Tidak</option><option value="Ya">Ya</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode VClaim</Form.Label>
              <Form.Control type="text" placeholder="Kosongkan jika tidak ada" value={formVclaim}
                onChange={e => setFormVclaim(e.target.value)} style={styles.formControl} />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2 border-top pt-2">
              <Button type="button" variant="secondary" size="sm" onClick={handleClearT}>Batal</Button>
              <Button type="submit" size="sm" className="fw-bold" style={styles.btnSave}>
                <i className="bi bi-hdd-fill me-1"></i> Simpan Tindakan
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ══════════════ MODAL FORM KELOMPOK ══════════════ */}
      <Modal show={showModalK} onHide={handleClearK} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1e1b4b 0%, #7c3aed 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-collection-fill text-warning fs-5"></i>
            <span>{isEditingK ? `Edit Kelompok: ${formKdK}` : 'Tambah Kelompok Tindakan Baru'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSubmitK}>
            <Form.Group className="mb-2">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode Kelompok</Form.Label>
              <Form.Control type="text" placeholder="Contoh: 001" value={formKdK}
                onChange={e => setFormKdK(e.target.value)} disabled={isEditingK} required style={styles.formControl} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Kelompok</Form.Label>
              <Form.Control type="text" placeholder="Contoh: Jasa Dokter Umum" value={formNmK}
                onChange={e => setFormNmK(e.target.value)} required style={styles.formControl} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Paket</Form.Label>
              <Form.Select value={formPaket} onChange={e => setFormPaket(e.target.value)} style={styles.formSelect}>
                <option value="Tidak">Tidak</option><option value="Ya">Ya</option>
              </Form.Select>
            </Form.Group>
            <div className="d-flex justify-content-end gap-2 border-top pt-2">
              <Button type="button" variant="secondary" size="sm" onClick={handleClearK}>Batal</Button>
              <Button type="submit" size="sm" className="fw-bold" style={styles.btnSaveK}>
                <i className="bi bi-hdd-fill me-1"></i> Simpan Kelompok
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: { minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)', display: 'flex', flexDirection: 'column' },
  navbarCustom: { background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', padding: '0.25rem 1rem', flexShrink: 0 },
  mainContent: { flex: 1, padding: '0.4rem', overflowY: 'auto' },
  mainCard: { borderRadius: '12px', border: '1.5px solid #cbd5e1', boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)', background: '#ffffff', overflow: 'hidden' },
  bgMenuHeader: { background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)' },
  formControl: { fontSize: '0.75rem', borderRadius: '6px', padding: '0.35rem 0.6rem', border: '1px solid #cbd5e1', color: '#0f172a' },
  formSelect: { fontSize: '0.75rem', borderRadius: '6px', padding: '0.35rem 0.6rem', border: '1px solid #cbd5e1', color: '#0f172a' },
  btnSave:  { background: '#0d9488', borderColor: '#0d9488', color: '#ffffff', fontSize: '0.78rem' },
  btnSaveK: { background: '#7c3aed', borderColor: '#7c3aed', color: '#ffffff', fontSize: '0.78rem' },
  actionBtn: { padding: '0.2rem 0.4rem', fontSize: '0.7rem' },
  badge: { fontSize: '0.7rem', fontWeight: '600', padding: '3px 7px', borderRadius: '20px' },
};

export default DataTindakan;
